import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Card, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getLead, updateLead } from "../../store/slices/leads";
import { emailregex, nameregex, mobileregex } from "../../utils/Regex";
import { useNavigate, Link, useParams } from "react-router-dom";

export default function EditLeads() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { id } = useParams();



  // fetchlead data
  const fetchLead = async () => {
    try {
      const response = await dispatch(getLead({ id })).unwrap();

      const data = response?.leads?.[0];

      setLead({
        name: data.name || "",
        email: data.email || "",
        phone: data.phone ? data.phone.toString() : "",
        country: data.country || "",
        source: data.source || "",
        sourceReference: data.sourceReference || "",
        tentativeTravelDate: formatDate(data.tentativeTravelDate),
        durationNights:
          data.durationNights != null ? data.durationNights.toString() : "",
        adults: data.adults != null ? data.adults.toString() : "",
        children: data.children != null ? data.children.toString() : "",
        budget: data.budget != null ? data.budget.toString() : "",
        currency: data.currency || "",
        priority: data.priority || "",
        nextFollowUpDate: formatDate(data.nextFollowUpDate),
        notes: data.notes || "",
      });
    } catch (error) {
      console.error("Failed to fetch lead", error);
    }
  };

  useEffect(() => {
    fetchLead();
  }, []);

  const initialState = {
    name: "",
    email: "",
    phone: "",
    country: "",
    source: "",
    sourceReference: "",
    tentativeTravelDate: "",
    durationNights: "",
    adults: "",
    children: "",
    budget: "",
    currency: "",
    priority: "",
    nextFollowUpDate: "",
    notes: "",
  };

  const [lead, setLead] = useState(initialState);

  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  // convert date format
  const formatDate = (date) => {
    if (!date) return "";
    return date.split("T")[0];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    let error = "";

    if (name === "name") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter name";
      } else if (updatedValue.length > 30) {
        error = "Name maximum 30 characters only";
      }
    }

    if (name === "email") {
      updatedValue = value;

      if (!updatedValue.trim()) {
        error = "Please enter email";
      } else if (updatedValue.includes(" ")) {
        error = "Email should not contain spaces";
      } else if (!emailregex.test(updatedValue)) {
        error = "Please enter valid email";
      } else if (!/^[^\s@]+@[^\s@]+\.com$/.test(updatedValue)) {
        error = "Email must end with .com";
      }
    }

    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter phone number";
      } else if (!mobileregex.test(updatedValue)) {
        error = "Please enter valid 10 digit number";
      }
    }

    if (name === "country") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter country";
      } else if (updatedValue.length > 30) {
        error = "Country maximum 30 characters only";
      }
    }

    if (name === "source") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter source";
      } else if (updatedValue.length > 20) {
        error = "Source maximum 30 characters only";
      }
    }

    if (name === "sourceReference") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter source reference";
      } else if (updatedValue.length > 20) {
        error = "Source reference maximum 20 characters only";
      }
    }

    if (name === "tentativeTravelDate") {
      const today = new Date().toISOString().split("T")[0];

      if (!updatedValue) {
        error = "Please select travel date";
      } else if (updatedValue < today) {
        error = "Past date is not allowed";
      }
    }

    if (name === "durationNights") {
      updatedValue = value.replace(/\D/g, "");

      if (!String(!updatedValue.trim())) {
        error = "Please enter duration nights";
      }
    }

    if (name === "adults") {
      updatedValue = value.replace(/\D/g, "");

      if (updatedValue.length > 2) {
        updatedValue = updatedValue.slice(0, 2);
      }

      if (!updatedValue.trim()) {
        error = "Please enter adults";
      }
    }

    if (name === "children") {
      updatedValue = value.replace(/\D/g, "");

      if (updatedValue.length > 2) {
        updatedValue = updatedValue.slice(0, 2);
      }

      if (!updatedValue.trim()) {
        error = "Please enter children";
      }
    }

    if (name === "budget") {
      updatedValue = value.replace(/\D/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter budget";
      } else {
        const numericValue = Number(updatedValue);

        if (numericValue < 20000) {
          error = "Budget must be minimum 10000";
        } else if (numericValue > 500000) {
          error = "Budget cannot exceed 500000";
        }
      }
    }

    if (name === "currency") {
      updatedValue = value.toUpperCase().replace(/[^A-Z]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter currency";
      } else if (updatedValue.length !== 3) {
        error = "Currency must be 3 letter code (e.g. INR)";
      }
    }

    if (name === "priority") {
      if (!updatedValue.trim()) {
        error = "Please select priority";
      }
    }

    if (name === "nextFollowUpDate") {
      if (!updatedValue) {
        error = "Please select follow up date";
      }
    }

    if (name === "notes") {
      if (updatedValue.length > 100) {
        error = "Notes maximum 100 characters only";
      }
    }

    setLead((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validateLead = () => {
    let newErrors = {};

    if (!lead.name.trim()) {
      newErrors.name = "Please enter name";
    }

    if (!lead.email.trim()) {
      newErrors.email = "Please enter email";
    }

    if (!lead.phone.trim()) {
      newErrors.phone = "Please enter phone number";
    }

    if (!lead.country.trim()) {
      newErrors.country = "Please enter country";
    }

    if (!lead.source.trim()) {
      newErrors.source = "Please enter source";
    }

    if (!lead.sourceReference.trim()) {
      newErrors.sourceReference = "Please enter source reference";
    }

    if (!lead.tentativeTravelDate) {
      newErrors.tentativeTravelDate = "Please select travel date";
    }

    if (!String(lead.durationNights).trim()) {
      newErrors.durationNights = "Please enter duration nights";
    }

    if (!lead.adults.trim()) {
      newErrors.adults = "Please enter adults";
    }

    if (!lead.children.trim()) {
      newErrors.children = "Please enter children";
    }

    if (!lead.budget.trim()) {
      newErrors.budget = "Please enter budget";
    }

    if (!lead.currency.trim()) {
      newErrors.currency = "Please enter currency";
    }

    if (!lead.priority.trim()) {
      newErrors.priority = "Please select priority";
    }

    if (!lead.nextFollowUpDate) {
      newErrors.nextFollowUpDate = "Please select follow up date";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate
    const validationErrors = validateLead();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true)

    try {
      const payload = {
        id,
        ...lead,
      };

      await dispatch(updateLead(payload)).unwrap();

      toast.success("Lead Update successfully!");

      navigate("/hotel/lead");
      setLead(initialState);

      setErrors({});
    } catch (error) {
      toast.error(error || "Failed to update lead");
    } finally {
      setLoading(false)
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-3">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>
          |
          <Link to="/hotel/lead" className="breadcrumb-link active">
            Lead list
          </Link>
          | <span className="breadcrumb-link inactive">Edit Lead</span>
        </div>
      </div>

      <Container className="mt-4">
        <Card style={{ border: "none" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              {/* Row 1 - > */}
              <Row className="my-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      name="name"
                      value={lead.name}
                      onChange={handleChange}
                      maxLength={30}
                      placeholder="Enter name"
                    />
                    <small className="text-danger">{errors.name}</small>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      name="email"
                      value={lead.email}
                      onChange={handleChange}
                      maxLength={30}
                      placeholder="Enter email"
                    />
                    <small className="text-danger">{errors.email}</small>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      name="phone"
                      value={lead.phone}
                      onChange={handleChange}
                      maxLength={10}
                      placeholder="Enter phone number"
                    />
                    <small className="text-danger">{errors.phone}</small>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row <- 2 */}
              <Row className="my-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      name="country"
                      value={lead.country}
                      onChange={handleChange}
                      maxLength={30}
                      placeholder="Enter country"
                    />
                    <small className="text-danger">{errors.country}</small>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Source</Form.Label>
                    <Form.Control
                      name="source"
                      value={lead.source}
                      onChange={handleChange}
                      placeholder="Enter source"
                      maxLength={20}
                    />
                    <small className="text-danger">{errors.source}</small>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Source Reference</Form.Label>
                    <Form.Control
                      name="sourceReference"
                      value={lead.sourceReference}
                      onChange={handleChange}
                      maxLength={20}
                      placeholder="Enter source reference"
                    />
                    <small className="text-danger">
                      {errors.sourceReference}
                    </small>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 3 -> */}
              <Row className="my-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Travel Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="tentativeTravelDate"
                      value={lead.tentativeTravelDate}
                      onChange={handleChange}
                      min={new Date().toISOString().split("T")[0]}
                    />
                    <small className="text-danger">
                      {errors.tentativeTravelDate}
                    </small>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Duration Nights</Form.Label>
                    <Form.Control
                      name="durationNights"
                      value={lead.durationNights}
                      onChange={handleChange}
                      placeholder="Enter duration nights "
                      maxLength={10}
                    />
                    <small className="text-danger">
                      {errors.durationNights}
                    </small>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Adults</Form.Label>
                    <Form.Control
                      name="adults"
                      value={lead.adults}
                      onChange={handleChange}
                      maxLength={2}
                      placeholder="Enter adults "
                    />
                    <small className="text-danger">{errors.adults}</small>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 4 - > */}
              <Row className="my-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Children</Form.Label>
                    <Form.Control
                      name="children"
                      value={lead.children}
                      onChange={handleChange}
                      maxLength={2}
                      placeholder="Enter children"
                    />
                    <small className="text-danger">{errors.children}</small>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Budget</Form.Label>
                    <Form.Control
                      name="budget"
                      value={lead.budget}
                      onChange={handleChange}
                      placeholder="Enter budget"
                      maxLength={6}
                    />
                    <small className="text-danger">{errors.budget}</small>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Currency</Form.Label>
                    <Form.Control
                      name="currency"
                      value={lead.currency}
                      onChange={handleChange}
                      maxLength={5}
                      placeholder="Enter currency"
                    />
                    <small className="text-danger">{errors.currency}</small>
                  </Form.Group>
                </Col>
              </Row>

              {/* Row <-  5 */}
              <Row className="my-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Priority</Form.Label>
                    <Form.Select
                      name="priority"
                      value={lead.priority}
                      onChange={handleChange}
                    >
                      <option value="">Select Priority</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </Form.Select>
                    <small className="text-danger">{errors.priority}</small>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Next Follow Up</Form.Label>
                    <Form.Control
                      type="date"
                      name="nextFollowUpDate"
                      value={lead.nextFollowUpDate}
                      onChange={handleChange}
                      min={new Date().toISOString().split("T")[0]}
                    />
                    <small className="text-danger">
                      {errors.nextFollowUpDate}
                    </small>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="my-2">
                <Col lg={12}>
                  <Form.Group>
                    <Form.Label>Notes (Optional)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="notes"
                      value={lead.notes}
                      onChange={handleChange}
                      maxLength={100}
                      placeholder="Enter notes"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Buttons */}
              <div className="text-center mt-5 mb-5">
                <button
                  type="button"
                  className="cancel-btn me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>

                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="light"
                        className="me-2"
                      />
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
